module.exports = __webpack_public_path__ + "static/Wild Poster Specs 2026-18c3fd55ac833cc45aec97ba22429a8e.pdf";